<template>
    <div class="bg-white rounded px-5 pt-5">
        <h3 class="mb-4" style="color: #1a0054">
            <strong>Crea tus rutas</strong>
        </h3>

        <h4 class="mb-4"><strong>Creación de ruta</strong></h4>

        <p class="mb-4">
            Puedes crear una ruta a partir de cursos existentes. Elige el
            contenido ideal para tus colaboradores.
        </p>

        <div class="col-12 mb-3">
            <label for="info-nombre-ruta"><b>Nombre de la ruta *</b></label>
            <input
                type="text"
                id="info-nombre-ruta"
                placeholder="Nombre de la ruta"
                v-model.trim="route.name"
                class="form-control rounded-8 sin-borde"
                @input="clearError('routeName')"
            />
            <small v-if="errors.routeName" class="text-danger">{{
                errors.routeName
            }}</small>
        </div>

        <div class="col-12 mb-3">
            <label for="info-descripcion"><b>Descripción</b></label>
            <textarea
                id="info-descripcion"
                :placeholder="descriptionPlaceholder"
                v-model="route.description"
                class="form-control rounded-8 sin-borde"
                :maxlength="MAX_DESCRIPTION_LENGTH"
                cols="30"
                rows="4"
            ></textarea>
            <small class="text-muted"
                >{{ descriptionCount }}/{{
                    MAX_DESCRIPTION_LENGTH
                }}
                caracteres</small
            >
        </div>

        <div class="col-12 mb-3">
            <label for="info-tiempo"><b>Tiempo de vigencia</b></label>
            <input
                type="number"
                id="info-tiempo"
                placeholder="Tiempo en número"
                v-model.number="route.validity_time"
                class="form-control rounded-8 sin-borde"
                min="0"
                @input="clearError('validityTime')"
            />
            <small v-if="errors.validityTime" class="text-danger">{{
                errors.validityTime
            }}</small>
        </div>

        <div class="col-12 mb-3">
            <label for="type_period"><b>Tipo de tiempo</b></label>
            <select
                class="form-control rounded-8 sin-borde"
                v-model="route.type_period"
                id="type_period"
                @change="clearError('typePeriod')"
            >
                <option value="">Seleccione una opción</option>
                <option value="horas">Horas</option>
                <option value="dias">Días</option>
                <option value="meses">Meses</option>
            </select>
            <small v-if="errors.typePeriod" class="text-danger">{{
                errors.typePeriod
            }}</small>
        </div>

        <div class="col-12 text-end">
            <button
                class="btn bg-utel-v2-secondary sin-borde text-primary rounded-8 mx-1 my-sm-2 pt-2"
                @click="cancel"
            >
                Cancelar
            </button>
            <button
                class="btn bg-utel text-white sin-borde rounded-8 px-5"
                :disabled="isValidating"
                @click="continueToNextStep"
            >
                <span
                    v-if="isValidating"
                    class="spinner-border spinner-border-sm me-1"
                ></span>
                {{ isValidating ? "Validando..." : "Continuar" }}
            </button>
        </div>
    </div>
</template>

<script>
const MAX_DESCRIPTION_LENGTH = 600;

const createEmptyRoute = () => ({
    name: "",
    description: "",
    type_period: "",
    validity_time: "",
    courses: [],
    students: [],
});

export default {
    name: "CreateCustomRouteInformation",
    props: {
        info: { type: Object, required: true },
        client: { type: [String, Object], required: true },
        url_get_route_validation: { type: String, required: true },
    },
    emits: ["setRuta", "changeStep"],
    data() {
        return {
            MAX_DESCRIPTION_LENGTH,
            route: createEmptyRoute(),
            errors: {
                routeName: "",
                validityTime: "",
                typePeriod: "",
            },
            isValidating: false,
        };
    },
    computed: {
        descriptionCount() {
            return this.route.description?.length || 0;
        },
        descriptionPlaceholder() {
            return `Descripción de la ruta (0/${MAX_DESCRIPTION_LENGTH} caracteres)`;
        },
    },
    mounted() {
        if (this.info.name) {
            this.route = { ...this.info };
        }
    },
    methods: {
        clearError(field) {
            this.errors[field] = "";
        },
        clearAllErrors() {
            Object.keys(this.errors).forEach((key) => {
                this.errors[key] = "";
            });
        },
        validateForm() {
            this.clearAllErrors();
            let isValid = true;

            if (!this.route.name) {
                this.errors.routeName = "Debe ingresar un nombre de ruta.";
                isValid = false;
            }

            if (this.route.validity_time && !this.route.type_period) {
                this.errors.typePeriod = "Debe seleccionar el tipo de tiempo.";
                isValid = false;
            }

            if (this.route.validity_time && this.route.validity_time <= 0) {
                this.errors.validityTime = "El tiempo debe ser mayor a 0.";
                isValid = false;
            }

            return isValid;
        },
        async checkDuplicateRoute(routeName, client) {
            try {
                const { data } = await axios.post(
                    this.url_get_route_validation,
                    {
                        uuid: client,
                        nombreruta: routeName,
                    }
                );
                return data.existe;
            } catch (error) {
                console.error("Error validando ruta:", error);
                return false;
            }
        },
        async continueToNextStep() {
            if (!this.validateForm()) {
                return;
            }

            this.isValidating = true;

            try {
                const isDuplicate = await this.checkDuplicateRoute(
                    this.route.name,
                    this.client
                );

                if (isDuplicate) {
                    this.errors.routeName =
                        "La ruta ya existe en la empresa actual.";
                    return;
                }

                this.$emit("setRuta", this.route);
                this.$emit("changeStep", 2);
            } finally {
                this.isValidating = false;
            }
        },
        cancel() {
            this.$emit("setRuta", createEmptyRoute());
            this.$emit("changeStep", 0);
        },
    },
};
</script>
